import React from "react";
import {
  View,
  Text,
  TouchableOpacity,
  FlatList,
  StyleSheet,
} from "react-native";
import WizardFooter from "./WizardFooter";

const ExistingFlowsStep = ({
  selectedProperty,
  existingFlows = [],
  onBack,
  onNext,
}) => {
  const getLeadT = (row) => {
    const leadTenant = row?.tenants?.find(
      (t) => t?.is_lead
    );
    if (!leadTenant) return "N/A";

    return `${leadTenant?.app_user?.user?.first_name} ${leadTenant?.app_user?.user?.last_name}`;
  };

  const handleSelect = (flow) => {
    const flowSummary = {
      flowId: flow?.openflow_id || flow?.id,
      percentageCompleted:
        flow?.percentage_completed || 0,
      leadTenant: getLeadT(flow),
      property: selectedProperty,
      isNew: false,
    };

    onNext(flowSummary);
  };


  return (
    <View style={styles.container}>
      <Text style={styles.title}>
        Existing Flows for {selectedProperty?.name}
      </Text>

      {existingFlows?.length > 0 ? (
        <FlatList
          data={existingFlows}
          keyExtractor={(item) =>
            item.id?.toString()
          }
          renderItem={({ item }) => (
            <View style={styles.row}>
              <Text style={styles.cell}>
                {getLeadT(item)}
              </Text>
              <Text style={styles.cell}>
                {item?.percentage_completed || 0}%
              </Text>
              <TouchableOpacity
                style={styles.continueButton}
                onPress={() =>
                  handleSelect(item)
                }
              >
                <Text style={styles.whiteText}>
                  CONTINUE
                </Text>
              </TouchableOpacity>
            </View>
          )}
        />
      ) : (
        <Text style={{ marginVertical: 15 }}>
          No existing flows found.
        </Text>
      )}

<WizardFooter
  leftLabel="Back"
  rightLabel="Continue"
  onLeftPress={onBack}
  showRight={false}
/>


    </View>
  );
};



const styles = StyleSheet.create({
  container: {
    padding: 20,
  },
  title: {
    fontSize: 18,
    fontWeight: "600",
    color: "#7D57C1",
    marginBottom: 20,
  },
  row: {
    flexDirection: "row",
    alignItems: "center",
    paddingVertical: 12,
    borderBottomWidth: 1,
    borderColor: "#eee",
  },
  cell: {
    flex: 1,
    textAlign: "center",
  },
  continueButton: {
    flex: 1,
    backgroundColor: "#35b1c8",
    padding: 8,
    borderRadius: 6,
  },
  footer: {
    flexDirection: "row",
    marginTop: 25,
  },
  startButton: {
    backgroundColor: "#7D57C1",
    padding: 10,
    borderRadius: 6,
  },
  backText: {
    color: "#d81b60",
    fontWeight: "600",
  },
  whiteText: {
    color: "#fff",
    textAlign: "center",
    fontWeight: "600",
  },
});

export default ExistingFlowsStep;